import useMedia from "utils/hooks/useMedia";

const useNumCardsInRow = (width?: number, breakpointsArray?: number[]) => {
  const breakpoints = breakpointsArray ?? [600, 1650, 2000];
  const values = [1, 2, 3];
  const defaultValue = 4;
  let numCardsInRow = useMedia(
    breakpoints.map((breakpoint) => `(max-width: ${breakpoint}px)`),
    values,
    defaultValue
  );

  if (width) {
    for (const [i, breakpoint] of breakpoints.entries()) {
      if (width < breakpoint) {
        return values[i];
      }
    }
    return defaultValue;
  }

  return numCardsInRow;
};

export default useNumCardsInRow;
